import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getYearlyReports } from '../../../store/actions/reports/reports_action';
import { Paper, makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { roundNumber } from '../../../utils/helper_functions';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },
    table: {
        minWidth: 500,
        whiteSpace: 'noWrap',
        "& th, & td": {
            padding: '8px'
        }
    },
    tableRow: {
        cursor: 'pointer'
    }
}));

const YearlyReportsTable = ({ yearlyReports: { collection } }) => {
    const { paper, table, tableRow } = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!collection.length) {
            dispatch(getYearlyReports());
        }
    }, []);

    return (
            <Paper className={paper}>
                <Table aria-label="table" className={table}>
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell>Januar</TableCell>
                            <TableCell>Februar</TableCell>
                            <TableCell>Mart</TableCell>
                            <TableCell>April</TableCell>
                            <TableCell>Maj</TableCell>
                            <TableCell>Jun</TableCell>
                            <TableCell>Jul</TableCell>
                            <TableCell>Avgust</TableCell>
                            <TableCell>Septembar</TableCell>
                            <TableCell>Oktobar</TableCell>
                            <TableCell>Novembar</TableCell>
                            <TableCell>Decembar</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Godina</TableCell>
                            <TableCell>Prihod / Trošak</TableCell>
                            <TableCell>Prihod / Trošak</TableCell>
                            <TableCell>Prihod / Trošak</TableCell>
                            <TableCell>Prihod / Trošak</TableCell>
                            <TableCell>Prihod / Trošak</TableCell>
                            <TableCell>Prihod / Trošak</TableCell>
                            <TableCell>Prihod / Trošak</TableCell>
                            <TableCell>Prihod / Trošak</TableCell>
                            <TableCell>Prihod / Trošak</TableCell>
                            <TableCell>Prihod / Trošak</TableCell>
                            <TableCell>Prihod / Trošak</TableCell>
                            <TableCell>Prihod / Trošak</TableCell>
                            <TableCell>Saldo</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {collection.map(({
                            year,
                            januaryIncome, februaryIncome, marchIncome, aprilIncome, mayIncome, juneIncome, julyIncome, augustIncome, septemberIncome, octoberIncome, novemberIncome, decemberIncome, totalIncome,
                            januaryExpense, februaryExpense, marchExpense, aprilExpense, mayExpense, juneExpense, julyExpense, augustExpense, septemberExpense, octoberExpense, novemberExpense, decemberExpense, totalExpense
                            }, index) =>
                            <TableRow hover key={index} className={tableRow}>
                                <TableCell>{ year }</TableCell>
                                <TableCell>{ roundNumber(januaryIncome) } / { roundNumber(januaryExpense) }</TableCell>
                                <TableCell>{ roundNumber(februaryIncome) } / { roundNumber(februaryExpense) }</TableCell>
                                <TableCell>{ roundNumber(marchIncome) } / { roundNumber(marchExpense) }</TableCell>
                                <TableCell>{ roundNumber(aprilIncome) } / { roundNumber(aprilExpense) }</TableCell>
                                <TableCell>{ roundNumber(mayIncome) } / { roundNumber(mayExpense) }</TableCell>
                                <TableCell>{ roundNumber(juneIncome) } / { roundNumber(juneExpense) }</TableCell>
                                <TableCell>{ roundNumber(julyIncome) } / { roundNumber(julyExpense) }</TableCell>
                                <TableCell>{ roundNumber(augustIncome) } / { roundNumber(augustExpense) }</TableCell>
                                <TableCell>{ roundNumber(septemberIncome) } / { roundNumber(septemberExpense) }</TableCell>
                                <TableCell>{ roundNumber(octoberIncome) } / { roundNumber(octoberExpense) }</TableCell>
                                <TableCell>{ roundNumber(novemberIncome) } / { roundNumber(novemberExpense) }</TableCell>
                                <TableCell>{ roundNumber(decemberIncome) } / { roundNumber(decemberExpense) }</TableCell>
                                <TableCell>{ roundNumber(parseFloat(totalIncome || 0) - parseFloat(totalExpense || 0)) }</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Paper>
    )
}

YearlyReportsTable.propTypes = {
    yearlyReports: PropTypes.object
}

const mapStateToProps = (state) => ({
    yearlyReports: state.yearlyReports
});

export default connect(mapStateToProps)(YearlyReportsTable);
